import React, { Fragment } from 'react';
import { getPagePath } from '@spotahome/bff/client';
import { getLoggedInUserInfo } from '@spotahome/soyuz-auth-client';
import {
  LoginButton as LoginButtonComponent,
  ToastContainer
} from '@spotahome/ui-library';

import '@spotahome/ui-library/lib/components/Toast.css';
import '@spotahome/ui-library/lib/components/Dropdown.css';
import '@spotahome/ui-library/lib/components/DropdownItem.css';
import '@spotahome/ui-library/lib/components/MobileMenu.css';
import '@spotahome/ui-library/lib/components/Header.css';
import '@spotahome/ui-library/lib/components/LoginButton.css';

import './LoginModalStyles';

import withModalProps from './withModalProps';

const LoginButton = props => (
  <Fragment>
    <LoginButtonComponent
      isMobile={props.isMobile}
      logoutPath={getPagePath('externals.logout')}
      getLoggedInUserInfo={getLoggedInUserInfo}
      modalProps={props.modalProps}
      color="light"
      userAreaPath={getPagePath('externals.my-requests')}
      searchPreferencePath={getPagePath(
        'externals.landing-pages.search-preferences'
      )}
      myProfilePath={getPagePath('externals.my-profile')}
    />
    <ToastContainer />
  </Fragment>
);

export default withModalProps()(LoginButton);
